module.exports = __webpack_public_path__ + "static/img/new_icon_2_preview.e1fcd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newImages/new_icon_2_preview.png
// module id = 1403
// module chunks = 4